export default __webpack_public_path__ + "static/media/auth_info.72828908.png";